<template>
  <CRUDDialog ref="crudDialog" :baseCrudKey="dialogCrudKey"
  dialogDynamicWidth="40vw"
  dialogHeaderName="Personal Tax Warrants Information"
  :canSave="true"   @upsertItem="upsertTransaction">
    <template v-slot:[`editedItem`]="{ }">
      <template class="">
        <div class="input-text-size pa-0 ma-0 custom-red-text">{{ errorMessage || ''}}</div>
        <div v-if="ownerName!=''" class="input-text-size pa-0 ma-0">
  <span class="font-weight-bold">Owner Name:</span> {{ ownerName || 'N/A' }}
</div>
            <div class="scrollable-ctnr pt-6 pb-0 ma-0">
            <v-row dense justify="space-around" class="">
            <v-col cols='6' class='pt-0 pb-0 my-n4'>
              <CommonDropDowns :isItTaxYearWithoutAllYears=true
              @change="dataFromCommonDropDowns"
               :taxYearValue="editedItem.taxYear"/></v-col>
                <v-col cols="6" class="pt-0 pb-0">
                  <v-text-field class='input-text-size pa-0 ma-0'
                  v-model.number="editedItem.taxId"
                   @change="handleTaxInquiry"
                  >
                  <template v-slot:label>
                    <label>TID</label>
                  </template>
                </v-text-field></v-col>
                <v-col cols="6" class="pt-0 pb-0">
                  <v-text-field class='input-text-size pa-0 ma-0'
                  v-model.number="editedItem.warrantNumber"
                  >
                  <template v-slot:label>
                    <label>Warrant No</label>
                  </template>
                </v-text-field>
                </v-col>
                <v-col cols="6" class="pt-0 pb-0">
                  <v-text-field class='input-text-size pa-0 ma-0'
                  v-model="editedItem.aliasNumber" >
                  <template v-slot:label>
                    <label>Alias No</label>
                  </template>
                </v-text-field>
                </v-col>
            </v-row>
            <v-row class="">
              <v-col cols="6" class="pt-0 pb-0">
                  <v-text-field class='input-text-size pa-0 ma-0 ' readonly
                  v-model="editedItem.sherifFee">
                  <template v-slot:label>
                    <label>Sheriff Fee</label>
                  </template>
                </v-text-field>
              </v-col>
              <v-col cols="6" class="pt-0 pb-0 ">
                  <v-text-field class='input-text-size pa-0 ma-0 '
                  v-model.number="editedItem.sherifFeeAmount">
                  <template v-slot:label>
                    <label>Sheriff Fee Amount</label>
                  </template>
                </v-text-field>
              </v-col>
              <v-col cols="6" class="pt-0 pb-0">
                  <v-text-field class=' input-text-size pa-0 ma-0' readonly
                  v-model="editedItem.treasureFee">
                  <template v-slot:label>
                    <label>Treasurer Fee</label>
                  </template>
                </v-text-field>
              </v-col>
              <v-col cols="6" class="pt-0 pb-0">
                  <v-text-field class=' input-text-size pa-0 ma-0'
                  v-model.number="editedItem.treasureFeeAmount">
                  <template v-slot:label>
                    <label>Treasurer Fee Amount</label>
                  </template>
                </v-text-field>
              </v-col>
              <v-col cols="6" class="pt-0 pb-0">
                 <ClarionDateControl  class=' input-text-size pa-0 ma-0'
                :isToggle="false"
                :isIsoDate="true"
                 v-model="editedItem.penaltyDate" label="Penalty Date" />
               </v-col>
            </v-row>
          </div>

</template>

      </template>
  </CRUDDialog>

</template>

<script>
import {
  mapActions, mapMutations, mapGetters, mapState,
} from 'vuex';
import CRUDDialog from '../../../common/base/crud-2.0/CRUDDialog.vue';
import CommonDropDowns from '../../common-utils/CommonDropDowns.mixin.vue';
import { makeCriteriaStateNullIfEmptyString } from '../../common-utils/CommonTaxFunctionalities';
import { TaxWarrantsDialogMixin } from '../../warrants/utils/taxWarrants.mixin';
import {
  postProcessWarrantData,
} from '../../warrants/utils/taxWarrants.util';
import ClarionDateControl from '../../../common/ClarionDateControl.vue';

export default {
  name: 'TaxWarrantCreateDialog',
  mixins: [TaxWarrantsDialogMixin],
  components: {
    CRUDDialog,
    CommonDropDowns,
    ClarionDateControl,
  },
  props: {
    baseCrudKey: {
      type: String,
      default: '',
    },
  },
  data: () => ({
    dialogCrudKey: 'personalTaxWarrantCreate',
    errorMessage: null,
  }),
  computed: {
    ...mapGetters('base/crud', ['item', 'index', 'criteria', 'isVisible', 'items']),
    ...mapState({
      StoreSelItems: (state) => state.tax.taxWarrants.selectedItems,
    }),

    selectedItems: {
      get() {
        return this.StoreSelItems;
      },
      set(value) {
        this.setSelectedItems(value);
      },
    },
    criteriaState: {
      get() {
        return this.criteria(this.baseCrudKey) || {};
      },
      set(value) {
        this.setCriteria([this.baseCrudKey, value]);
      },
    },
    ownerName() {
      if (!this.editedItem) return '';
      return `${this.editedItem.name1 || ''}  ${this.editedItem.name2 || ''}`;
    },
  },
  watch: {
  },
  methods: {
    ...mapMutations('tax/taxWarrants', ['setSelectedItems']),
    ...mapMutations('base/crud', ['setCriteria', 'setItem']),
    ...mapActions('tax/taxWarrants', ['loadTaxWarrants', 'upsertWarrants', 'loadLastWarrantNo', 'loadLastSystemID']),

    // Override mixin methods to use the correct CRUD keys
    getEditedItemCrudKey() {
      return this.dialogCrudKey; // Use dialogCrudKey for editedItem
    },

    getUpsertCrudKey() {
      return this.baseCrudKey; // Use baseCrudKey for upsert operations
    },

    // Use utility function for post processing
    postProcessData(items) {
      return postProcessWarrantData(items);
    },

    setDefaultSelectedItems() {
      this.$nextTick(() => {
        this.selectedItems = [];
      });
    },

    async handleLoadWarrantList() {
      const { baseCrudKey } = this;
      const returnCriteria = makeCriteriaStateNullIfEmptyString(this.criteriaState);
      this.criteriaState = { ...returnCriteria };
      const criteria = {
        ...this.criteriaState,
        sortBy: [
          {
            column: 'warrantNumber',
            direction: 'desc',
          },
        ],
      };
      await this.loadTaxWarrants({
        criteria, baseCrudKey, postProcessTrans: this.postProcessData,
      }).then(() => {
        this.setDefaultSelectedItems();
      });
    },

    // Override the base upsert method with component-specific logic
    async afterUpsert() {
      // Custom post-upsert actions for this component
      this.handleLoadWarrantList();
      this.setDefaultSelectedItems();
    },
  },
};
</script>

<style scoped>
.custom-red-text {
  color: red;
  font-weight: bold;
}
</style>
